import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { sendRepairOrder } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewCom } from "@/mixins/index";
import { jsonDiff } from "diff/lib/diff/json";
import { itemTypeList } from "@/api/gmtool/packageCode";
export default {
  mixins: [gmToolNew, gmToolNewCom],
  data: function data() {
    return {
      dialogShow: false,
      paramsData: {
        uid: "",
        order_id: "",
        product_id: "",
        pay_type: "",
        pay_channel_order_id: "",
        reward: [],
        server_id: ""
      },
      rules: {
        uid: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: "blur"
        }],
        order_id: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: "blur"
        }],
        product_id: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: "blur"
        }],
        pay_type: [{
          required: true,
          message: this.$t('pleaseSelect'),
          trigger: "blur"
        }],
        reward: [{
          required: true,
          message: this.$t('pleaseAddItem'),
          trigger: "blur"
        }],
        item_type: [{
          required: true,
          message: this.$t('pleaseSelectItemType'),
          trigger: "blur"
        }],
        pay_channel_order_id: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: "blur"
        }],
        id: [{
          required: true,
          message: this.$t('pleaseSelectItem'),
          trigger: "blur"
        }],
        item_num: [{
          required: true,
          message: this.$t('pleaseEnterQuantity'),
          trigger: "blur"
        }],
        item_quality: [{
          required: true,
          message: this.$t('pleaseSelectItemQuality'),
          trigger: "blur"
        }],
        server_id: [{
          required: true,
          message: this.$t('pleaseSelect'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      var _this = this;

      this.getTypeList();
      this.itemType.map(function (i) {
        _this["itemType" + i.value] = _this.szgmItemList.filter(function (item) {
          return item.type == i.value;
        });
      });
      this.dialogShow = true;
    },
    getTypeList: function getTypeList() {
      var _this2 = this;

      itemTypeList({
        page_size: -1
      }).then(function (res) {
        if (res.code == 200) {
          _this2.itemType = res.data.map(function (item) {
            return {
              label: item.name,
              value: item.type_id
            };
          });
        }
      });
    },
    hiad: function hiad() {
      this.dialogShow = false;
    },
    addDomain: function addDomain() {
      this.paramsData.reward.push({
        num: "",
        type: "",
        id: "",
        quality: ""
      });
    },
    removeDomain: function removeDomain(item) {
      var index = this.paramsData.reward.indexOf(item);

      if (index !== -1) {
        this.paramsData.reward.splice(index, 1);
      }
    },
    domainType: function domainType(index, type) {
      this.paramsData.reward[index].id = "";

      if (this.paramsData.reward[index].num) {
        this.paramsData.reward[index].num = "";
      }
    },
    clearData: function clearData() {
      this.paramsData = {
        id: "",
        uid: "",
        order_id: "",
        pay_channel_order_id: "",
        product_id: "",
        pay_type: "",
        reward: [],
        server_id: ""
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this3.$confirm(_this3.$t('confirmSubmit'), _this3.$t('prompt'), {
            confirmButtonText: _this3.$t('confirm'),
            cancelButtonText: _this3.$t('cancel'),
            type: 'warning',
            beforeClose: function beforeClose(action, instance, done) {
              if (action === 'confirm') {
                instance.confirmButtonLoading = true;
                var data = JSON.parse(JSON.stringify(_this3.paramsData));
                data.reward = JSON.stringify(data.reward);
                sendRepairOrder(_objectSpread(_objectSpread({}, data), _this3.propsData)).then(function (res) {
                  if (res.code == 200 || res.status == 200) {
                    _this3.$message({
                      message: _this3.$t('operationSuccess'),
                      type: "success"
                    });

                    _this3.dialogShow = false;
                    done();
                    instance.confirmButtonLoading = false;

                    _this3.$emit("change");
                  } else {
                    done();
                    instance.confirmButtonLoading = false;
                  }
                });
              } else {
                done();
              }
            }
          });
        }
      });
    }
  }
};